<script setup lang="ts">
import { ref } from 'vue'
import DolphinTextarea from '@/components/atoms/DolphinTextarea.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

const props = defineProps<{
  initialMemo: string
}>()

const memo = ref(props.initialMemo)

const emits = defineEmits<{
  (e: 'update', memo: string): void
  (e: 'close'): void
}>()

const isUpdating = ref(false)

const handleClickSaveMemoButton = async () => {
  try {
    isUpdating.value = true

    emits('update', memo.value)
  } finally {
    isUpdating.value = false
  }
}

const handleClickCancelEditMemoButton = () => {
  const isChanging = memo.value !== props.initialMemo

  if (isChanging) {
    if (!confirm('編集中のメモを破棄しますか？')) {
      return
    }
  }

  emits('close')
}
</script>

<template>
  <div :class="$style.editModal">
    <p :class="$style.editModalTitle">メモ</p>
    <DolphinTextarea v-model="memo" placeholder="メモを記載" :rows="10" />
    <div :class="$style.buttonGroup">
      <FlatButton variant="base" @click="handleClickCancelEditMemoButton">
        キャンセル
      </FlatButton>
      <FlatButton @click="handleClickSaveMemoButton">保存する</FlatButton>
    </div>
  </div>
</template>

<style lang="scss" module>
.editModal {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 90vw;
  max-width: 600px;
}

.editModalTitle {
  font-weight: bold;
  font-size: 18px;
}

.buttonGroup {
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}
</style>
